import { ITableSort } from '../table-sorting.service';

enum SortRegExp {
    DateField = 'date'
}

// need if sorting && paging on ui side
class TableSort extends ITableSort{
    public sortRows(data: object[], field: string, sortState: string) {
        const dateRegExp = new RegExp(SortRegExp.DateField, 'gi');
        const sortedArray = data.sort((a, b) => {
            if (dateRegExp.test(field)) {
                const dateA = new Date(a[field]).valueOf();
                const dateB = new Date(b[field]).valueOf();
                return dateA - dateB;
            }
            if (typeof a[field] === 'number') {
                return a[field] - b[field];
            }
            if (typeof a[field] === 'string') {
                return a[field] < b[field] && -1;
            }
        });

        return sortState === 'asc'
            ? sortedArray
            : sortState === 'desc'
            ? sortedArray.reverse()
            : data;
    }
}

export { TableSort };
